<template>
  <div class="d-flex blocks sales-header text-left">
    <div class="d-flex p-0">
      <div class="col-1 d-flex">
        <a class="sales-sort" :class="[sortKey === 'first_name' ? 'selected' : '']" href="#" @click.prevent="sortBy('first_name')">
          <span>Salesperson</span>
          <i v-if="sortKey === 'first_name'" class="fa" :class="`fa-caret-${ascOrDesc}`" />
        </a>
      </div>
      <div class="flex-even d-flex">
        <div class="col-6">
          <a class="sales-sort" :class="[sortKey === 'total_jobs' ? 'selected' : '']" href="#" @click.prevent="sortBy('total_jobs')">
            <span>Total Books</span>
            <i v-if="sortKey === 'total_jobs'" class="fa" :class="`fa-caret-${ascOrDesc}`" />
          </a>
        </div>
        <div class="col-6">
          <a class="sales-sort" :class="[sortKey === 'total_leads' ? 'selected' : '']" href="#" @click.prevent="sortBy('total_leads')">
            <span>Total Leads</span>
            <i v-if="sortKey === 'total_leads'" class="fa" :class="`fa-caret-${ascOrDesc}`" />
          </a>
        </div>
      </div>
      <div class="flex-even d-flex">
        <div class="col-6">
          <a class="sales-sort" :class="[sortKey === 'phone_jobs' ? 'selected' : '']" href="#" @click.prevent="sortBy('phone_jobs')">
            <span>Phone Books</span>
            <i v-if="sortKey === 'phone_jobs'" class="fa" :class="`fa-caret-${ascOrDesc}`" />
          </a>
        </div>
        <div class="col-6">
          <a class="sales-sort" :class="[sortKey === 'phone_leads' ? 'selected' : '']" href="#" @click.prevent="sortBy('phone_leads')">
            <span>Phone Leads</span>
            <i v-if="sortKey === 'phone_leads'" class="fa" :class="`fa-caret-${ascOrDesc}`" />
          </a>
        </div>
      </div>
      <div class="flex-even d-flex">
        <div class="col-6">
          <a class="sales-sort" :class="[sortKey === 'website_jobs' ? 'selected' : '']" href="#" @click.prevent="sortBy('website_jobs')">
            <span>Website Books</span>
            <i v-if="sortKey === 'website_jobs'" class="fa" :class="`fa-caret-${ascOrDesc}`" />
          </a>
        </div>
        <div class="col-6">
          <a class="sales-sort" :class="[sortKey === 'website_leads' ? 'selected' : '']" href="#" @click.prevent="sortBy('website_leads')">
            <span>Website Leads</span>
            <i v-if="sortKey === 'website_leads'" class="fa" :class="`fa-caret-${ascOrDesc}`" />
          </a>
        </div>
      </div>
      <div class="flex-even d-flex">
        <div class="col-6">
          <a class="sales-sort" :class="[sortKey === 'yelp_chat_jobs' ? 'selected' : '']" href="#" @click.prevent="sortBy('yelp_chat_jobs')">
            <span>Yelp chat Books</span>
            <i v-if="sortKey === 'yelp_chat_jobs'" class="fa" :class="`fa-caret-${ascOrDesc}`" />
          </a>
        </div>
        <div class="col-6">
          <a class="sales-sort" :class="[sortKey === 'yelp_chat_leads' ? 'selected' : '']" href="#" @click.prevent="sortBy('yelp_chat_leads')">
            <span>Yelp chat Leads</span>
            <i v-if="sortKey === 'yelp_chat_leads'" class="fa" :class="`fa-caret-${ascOrDesc}`" />
          </a>
        </div>
      </div>
      <div class="flex-even d-flex">
        <div class="col-6">
          <a class="sales-sort" :class="[sortKey === 'no_availability_all' ? 'selected' : '']" href="#" @click.prevent="sortBy('no_availability_all')">
            <span>No Availability (all)</span>
            <i v-if="sortKey === 'no_availability_all'" class="fa" :class="`fa-caret-${ascOrDesc}`" />
          </a>
        </div>
        <div class="col-6">
          <a class="sales-sort" :class="[sortKey === 'no_availability_website' ? 'selected' : '']" href="#" @click.prevent="sortBy('no_availability_website')">
            <span>No Availability (website)</span>
            <i v-if="sortKey === 'no_availability_website'" class="fa" :class="`fa-caret-${ascOrDesc}`" />
          </a>
        </div>
      </div>
      <div class="col-1 d-flex">
        <a class="sales-sort" :class="[sortKey === 'mod_jobs' ? 'selected' : '']" href="#" @click.prevent="sortBy('mod_jobs')">
          <span>Mod24 Books</span>
          <i v-if="sortKey === 'mod_jobs'" class="fa" :class="`fa-caret-${ascOrDesc}`" />
        </a>
      </div>
      <div class="col-2 d-flex">
        <div class="col-4">
          <a class="sales-sort" :class="[sortKey === 'conversion_total' ? 'selected' : '']" href="#" @click.prevent="sortBy('conversion_total')">
            <span>Total Cnv</span>
            <i v-if="sortKey === 'conversion_total'" class="fa" :class="`fa-caret-${ascOrDesc}`" />
          </a>
        </div>
        <div class="col-4">
          <a class="sales-sort" :class="[sortKey === 'conversion_phone' ? 'selected' : '']" href="#" @click.prevent="sortBy('conversion_phone')">
            <span>Phone Cnv</span>
            <i v-if="sortKey === 'conversion_phone'" class="fa" :class="`fa-caret-${ascOrDesc}`" />
          </a>
        </div>
        <div class="col-4">
          <a class="sales-sort" :class="[sortKey === 'conversion_website' ? 'selected' : '']" href="#" @click.prevent="sortBy('conversion_website')">
            <span>Website Cnv</span>
            <i v-if="sortKey === 'conversion_website'" class="fa" :class="`fa-caret-${ascOrDesc}`" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SalesTableHeader',
  props: {
    sortKey: {
      type: String,
      default: '',
    },
    sortOrder: {
      type: String,
      default: '',
    },
  },
  computed: {
    ascOrDesc() {
      return this.sortOrder === 'asc' ? 'up' : 'down';
    },
  },
  methods: {
    sortBy(key) {
      this.$emit('sort-by', key);
    },
  },
};
</script>

<style lang="scss" scoped>
.sales-header {
  font-weight: 500;
  font-size: 12px;
}
a.sales-sort {
  color: #4c5669;
}
a.sales-sort.selected {
  color: #2962ff;
}
</style>



// WEBPACK FOOTER //
// src/components/reports/sales/SalesTableHeader.vue